<form [formGroup]="form">
  <h3 class="subtitulo">Prazo de atendimento</h3>
  <div class="form-group">
    <mat-radio-group [color]="'primary'" formControlName="nroSla">
      <mat-radio-button [checked]="120" value="120">5 dias</mat-radio-button>
      <mat-radio-button value="72">3 dias</mat-radio-button>
      <mat-radio-button value="48">2 dias</mat-radio-button>
      <mat-radio-button value="24">1 dia</mat-radio-button>
    </mat-radio-group>
  </div>
  <h3 class="subtitulo">Titulares</h3>
  <div formGroupName="titular">
    <div class="form-row">
      <div class="col-7">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>Nome</mat-label>
          <input matInput placeholder="Nome" formControlName="nome" maxlength="55" noSpecialChars />
          <mat-hint align="end">{{ nome.value?.length || 0 }} / 55</mat-hint>
          <mat-error *ngIf="nome.hasError('required')">
            Nome completo é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="nome.hasError('valueOnlyNumberError')">
            Nome do titular não pode conter apenas números
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-3">
        <mat-form-field appearance="outline" class="inputs">
          <mat-label>CPF/CNPJ</mat-label>
          <input matInput mask="000.000.000-00||00.000.000/0000-00" placeholder="CPF/CNPJ"
            formControlName="documento" />
          <mat-error *ngIf="documento.hasError('required')">
            CPF/CNPJ é <strong>obrigat&oacute;rio</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-center align-items-center col-auto">
        <button mat-button type="button" class="btn btn-branco" (click)="addTitular(nome.value, documento.value)">
          Adicionar
        </button>
      </div>
    </div>
  </div>

  <table mat-table class="mat-elevation-z2" [dataSource]="titulares" *ngIf="titulares.length > 0">
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let titular">{{ titular.nome }}</td>
    </ng-container>

    <ng-container matColumnDef="documento">
      <th mat-header-cell *matHeaderCellDef>Documento</th>
      <td mat-cell *matCellDef="let titular">
        {{ titular.documento | mask : (isPessoaFisica(titular.documento) ? "000.000.000-00" : "00.000.000/0000-00") }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Ações</th>
      <td mat-cell *matCellDef="let titular">
        <button mat-icon-button [matMenuTriggerFor]="menu" type="button">
          <mat-icon class="table-icon">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="after">
          <button (click)="removerTitular(titular)" mat-menu-item>
            <mat-icon class="table-icon">close</mat-icon>
            <span>Excluir</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <div class="form-row">
    <div class="info-message">
      <mat-icon class="info-icon" fontIcon="info"></mat-icon>
      <p>Se houver mais titulares, adicionar nesse momento!</p>
    </div>
  </div>

  <h3 class="subtitulo">Dados para inclusão</h3>

  <div class="form-row align-items-center">
    <div class="col-3">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Foro</mat-label>
        <mat-select formControlName="foro" required (selectionChange)="onChangeForo($event.value)" placeholder="Foro">
          <mat-option *ngFor="let foro of foros" [value]="foro">
            {{ foro.descricaoForo }}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="showSpinnerForo" align="end"><span class="float-left align-baseline">carregando foros </span>
          <mat-spinner class="float-lg-right" [diameter]="20"></mat-spinner>
        </mat-hint>
        <mat-error *ngIf="foro.hasError('required')">
          Foro é <strong>obrigat&oacute;rio</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Vara</mat-label>
        <mat-select required formControlName="vara" (selectionChange)="onChangeVara($event.value)" placeholder="Vara">
          <mat-option *ngFor="let vara of varas" [value]="vara">
            {{ vara.descricaoVara }}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="showSpinnerVara" align="end"><span class="float-left align-baseline">carregando varas </span>
          <mat-spinner class="float-lg-right" [diameter]="20"></mat-spinner>
        </mat-hint>
        <mat-error *ngIf="vara.hasError('required')">
          Vara é <strong>obrigat&oacute;rio</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-3">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Comarca</mat-label>
        <input matInput placeholder="Comarca" formControlName="comarca" />
      </mat-form-field>
    </div>

    <div class="col-3">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>UF</mat-label>
        <input matInput placeholder="UF" formControlName="uf" />
      </mat-form-field>
    </div>
  </div>

  <div class="form-row margin-bottom">
    <div class="col-4">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Valor da Dívida</mat-label>
        <input maxlength="16" value="" currencyMask required matInput [options]="{
            prefix: 'R$ ',
            suffix: '',
            thousands: '.',
            decimal: ','
          }" placeholder="Valor da Dívida" formControlName="vlrAcao" />
        <mat-error *ngIf="vlrAcao.hasError('required')">
          Valor da anotação é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="vlrAcao.hasError('valueZeroError')">
          O Valor não pode ser <strong>0,00</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-4">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Autor</mat-label>
        <input matInput required placeholder="Autor" formControlName="autor" maxlength="55" noSpecialChars />
        <mat-hint align="end">{{ autor.value?.length }} / 55</mat-hint>
        <mat-error *ngIf="autor.hasError('required')">
          Nome do autor / Exequente é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="autor.hasError('valueOnlyNumberError')">
          Nome do autor não pode conter apenas números
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Réu</mat-label>
        <input matInput required placeholder="Réu" formControlName="reu" maxlength="55" noSpecialChars />
        <mat-hint align="end">{{ reu.value?.length }} / 55</mat-hint>
        <mat-error *ngIf="reu.hasError('required')">
          Nome do réu / executado é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="reu.hasError('valueOnlyNumberError')">
          Nome do réu não pode conter apenas números
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="form-row">
    <div class="col-sm-12" *ngIf="comarca.value != 'RECIFE'">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Deseja comunicar o titular previamente ?
            </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            Carta Comunicado - É enviado ao(s) titular(es) da ação um comunicado
            a respeito da inclusão que será realizada no cadastrado de
            inadimplentes, com base no Art. 43, parágrafo segundo do Código de
            Defesa do Consumidor. A ação será incluída no cadastrado de
            inadimplentes da Serasa Experian após 10 dias corridos do
            cadastramento dessa ordem.
          </p>
          <mat-checkbox formControlName="cartaComunicado" [ngModelOptions]="{ standalone: true }">Comunicar previamente
            o titular ?</mat-checkbox>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-sm-7"></div>
    <div class="col-sm-5">
      <div class="form-row">
        <div class="form-group col-md-6">
          <button mat-raised-button (click)="handleInclusao()" [disabled]="disableInclusao()"
            class="btn btn-azul btn-block">
            Incluir Dívida
          </button>
        </div>
        <div class="form-group col-md-6">
          <button mat-raised-button (click)="cancelar()" class="btn btn-branco btn-block">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
